jQuery(document).ready(function(){	
	
	jQuery('.gallery-slider').slick({
	  	slidesToShow: 4,
		infinite: true,
		slidesToScroll: 1,
		dots: false,
		autoplay: false,
		prevArrow:'<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
		nextArrow:'<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
		responsive: [
			{
			  breakpoint: 760,
			  settings: {
		      	slidesToShow: 1
		      	//adaptiveHeight: true
			  }
			}
		]			
	});
	
	jQuery('.testimonial-slider.dark').slick({
	  	slidesToShow: 2,
		infinite: true,
		slidesToScroll: 2,
		dots: true,
		autoplay: false,
		prevArrow:'<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
		nextArrow:'<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
		responsive: [
			{
			  breakpoint: 760,
			  settings: {
		      	slidesToShow: 1,
		      	adaptiveHeight: true
			  }
			}
		]			
	});
	
	jQuery('.testimonial-slider.light').slick({
	  	slidesToShow: 3,
		infinite: true,
		slidesToScroll: 1,
		dots: true,
		autoplay: false,
		adaptiveHeight: true,
		prevArrow:'<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
		nextArrow:'<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
		responsive: [
			{
			  breakpoint: 760,
			  settings: {
		      	slidesToShow: 1,
		      	adaptiveHeight: true
			  }
			}
		]			
	});
	
});